import React from 'react'
import { ChildrenProps } from '../../modules/types'
import './TextBox.css'
import './Colors.css'

function TextBox(props: ChildrenProps) {
  const { error, className, ...rest } = props

  if (!error) {
    return (
      <input {...rest} className={`textbox ${className}`} {...error} />
    )
  } else {
    return (
      <input {...rest} className={`textbox-error ${className}`} {...error} />
    )
  }
}

export default TextBox
